import { RouteRecordRaw } from 'vue-router';

// HACK: Cuild be used to identify the device type
// import { Platform } from 'quasar'
// const device = Platform.is.desktop ? 'desktop' : 'mobile';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        name: 'Home',
        path: '',
        component: () => import('pages/Index.vue')
      },
      {
        name: 'AuthRecover',
        path: 'auth/recover',
        component: () => import('pages/Recover.vue')
      },
      {
        name: 'AuthMessage',
        path: 'auth/message',
        component: () => import('pages/Message.vue')
      },
      {
        name: 'ProfileIndex',
        path: 'profile',
        component: () => import('src/pages/profile/Index.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'PatientProfile',
        path: 'profile/patient/:identifier',
        component: () => import('src/pages/profile/Patient.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        name: 'PatientRecords',
        path: 'profile/patient/:identifier/records',
        component: () => import('src/pages/profile/records/Index.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        name: 'PatientAppointmentRecords',
        path: 'profile/patient/:identifier/records/appointments',
        component: () => import('src/pages/profile/records/Appointments.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        name: 'PractitionerProfile',
        path: 'profile/practitioner/:identifier',
        component: () => import('src/pages/profile/Practitioner.vue'),
        props: true
      },
      {
        name: 'HealthcareServiceProfile',
        path: 'profile/healthcareservice/:identifier',
        component: () => import('src/pages/profile/HealthcareService.vue'),
        props: true
      },
      {
        name: 'Explorer',
        path: 'explorer',
        component: () => import('pages/explorer/Index.vue')
      },
      /* {
        name: 'ExplorerOnDemand',
        path: 'explorer/onDemand',
        component: () => import('pages/explorer/OnDemand.vue'),
        meta: { requiresAuth: true }
      }, */
      {
        name: 'ExplorerPractitioners',
        path: 'explorer/practitioners',
        component: () => import('src/pages/explorer/Schedules.vue')
      },
      {
        name: 'ExplorerHealthcareServices',
        path: 'explorer/healthcareservices',
        component: () =>
          import('src/pages/explorer/modes/HealthcareServices.vue')
      },
      {
        name: 'ExplorerFavorites',
        path: 'explorer/favorites',
        component: () => import('src/pages/explorer/modes/Practitioners.vue')
      },
      {
        name: 'ExplorerSpecialties',
        path: 'explorer/specialties',
        component: () => import('src/pages/explorer/modes/Specialties.vue')
      },
      {
        name: 'ExplorerPractitionersConfirm',
        path: 'explorer/practitioners/:scheduleId',
        component: () => import('pages/explorer/Confirm.vue'),
        props: route => ({ ...route.params, ...route.query })
      },
      {
        name: 'ExplorerPractitionersSuccess',
        path: 'explorer/practitioners/success',
        component: () => import('pages/explorer/Success.vue'),
        props: true
      },
      {
        name: 'Bookings',
        path: 'bookings',
        component: () => import('src/pages/bookings/Index.vue')
      },
      {
        name: 'BookingsAppointments',
        path: 'bookings/appointments',
        component: () => import('src/pages/bookings/AppointmentsList.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'BookingsAppointmentsCode',
        path: 'bookings/appointments/:code',
        component: () => import('src/pages/bookings/Appointment.vue'),
        props: true
      },
      {
        name: 'AppointmentAccelerator',
        path: 'accelerate/appointments/:code',
        component: () =>
          import('src/pages/accelerator/AppointmentAccelerate.vue'),
        meta: { requiresAuth: true },
        props: true
      },
      {
        name: 'Accelerator',
        path: 'accelerate',
        component: () => import('src/pages/accelerator/AppointmentsList.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Services',
        path: 'services',
        component: () => import('src/pages/services/Index.vue'),
        props: true
      },
      {
        name: 'Benefits',
        path: 'services/benefits',
        component: () => import('src/pages/benefits/Index.vue')
      },
      {
        name: 'BenefitsServiceProvider',
        path: 'services/benefits/:provider',
        component: () => import('src/pages/benefits/Provider.vue'),
        props: true
      },
      {
        name: 'BenefitsProvider',
        path: 'benefits/:provider',
        component: () => import('src/pages/benefits/Provider.vue'),
        props: true
      },
      {
        name: 'ServicesViewer',
        path: 'services/viewer',
        component: () => import('src/pages/services/Viewer.vue'),
        props: true
      },
      {
        name: 'ServicesPharmacy',
        path: 'services/pharmacy',
        component: () => import('src/pages/services/Pharmacy.vue'),
        props: true
      },
      {
        name: 'ServicesExams',
        path: 'services/exams',
        component: () => import('src/pages/services/Exams.vue'),
        props: true
      },
      {
        name: 'Alliances',
        path: 'alliances',
        component: () => import('src/pages/alliances/Index.vue'),
        props: true
      },
      {
        name: 'AlliancesProvider',
        path: 'alliances/:provider',
        component: () => import('src/pages/alliances/Provider.vue'),
        props: true
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
];

export default routes;
